/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { OperationResponse } from '../models/generic/operation-response';
import { AcceptOrganisationInvitationResponse } from '../models/organisation-invitation/accept-organisation-invitation.response';
import { PendingOrganisationInvitation } from '../models/organisation-invitation/pending-organisation-invitation';

@Injectable({
  providedIn: 'root',
})
export class InvitationApi {
  constructor(private http: HttpClient) {}

  accept(invitationId: string): Observable<AcceptOrganisationInvitationResponse> {
    return this.http.post<AcceptOrganisationInvitationResponse>(
      `${environment.servicesApiUrl}/api/v1/invitations/${invitationId}/accept`,
      {},
    );
  }

  getCurrentUserPendingInvitations(): Observable<OperationResponse<PendingOrganisationInvitation>> {
    return this.http.get<OperationResponse<PendingOrganisationInvitation>>(
      `${environment.servicesApiUrl}/api/v1/invitations/pending`,
    );
  }
}
